import React, { useContext } from 'react'
import "./AddressProgressBreadCrumb.css"
import monthsDOB from 'components/StraightThroughHouseholdComp/CustomInputs/StateObjects/Months'

const breadcrumb = {
    borderRadius: '0.37rem',
    "--bs-breadcrumb-divider": "''",
    textDecoration: 'none'
}

const AddressProgressBreadCrumb = (props) => {
    const context = useContext(props?.requestContext)
    var requestClass = "addressChangeClass"

    // Helper function to convert month name to month index
    const monthNameToIndex = (monthName) => {
        const months = monthsDOB
        return months.indexOf(monthName);
    };

    // Calculates the age of the driver on changes of the dob fields
    const calculateAge = (dobMonth, dobDay, dobYear) => {
        const today = new Date();
        const birthMonthIndex = monthNameToIndex(dobMonth);
        const birthDate = new Date(dobYear, birthMonthIndex, dobDay);
        let age = today.getFullYear() - dobYear;
        const monthDifference = today.getMonth() - birthDate.getMonth();

        // Adjust age if the birthday hasn't happened yet this year
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < dobDay)) {
            age--;
        }
        return age;
    };

    const displayDriverAssignment = () => {
        var storedMembers = context?.addressChangeClass?.driversHHMs?.householdMembers?.storedMembers?.filter(member => member?.editType !== "");
        // Added driver form completed
        if (context?.addressChangeClass?.driversHHMs?.drivers?.newDrivers?.length > 0) return true;
        // Added household member as a driver
        else if (context?.addressChangeClass?.driversHHMs?.householdMembers?.newMembers?.length > 0 &&
            calculateAge(context?.addressChangeClass?.driversHHMs?.householdMembers?.newMembers[0]?.userInfo?.dobMonth, context?.addressChangeClass?.driversHHMs?.householdMembers?.newMembers[0]?.userInfo?.dobDay, context?.addressChangeClass?.driversHHMs?.householdMembers?.newMembers[0]?.userInfo?.dobYear) >= 16 &&
            context?.addressChangeClass?.driversHHMs?.householdMembers?.newMembers[0]?.driverInfo?.ownInsurance === "0")
            return true;
        // Updated household member "As a Driver"
        else if (storedMembers?.some((member) => member?.componentTracker === "Update HHM" && member?.editType === "Add as driver on policy.")) return true;
        else return false;
    }
    
    const navs =
        displayDriverAssignment() ?
            [
                '1. New Address',
                '2. Household',
                '3. Driver Assignment',
                '4. Confirm'
            ]
            :
            [
                '1. New Address',
                '2. Household',
                '3. Confirm'
            ]

    const isCurrent = ((value) => {
        const screen = props?.screen === undefined ? context[requestClass]?.screenName : props?.screen;
        return value.slice(3) === screen;
    });

    return (
        <>
            <div className="clearfix"></div>

            {/* Address Progress Bar */}
            <div className="col-12">
                <nav>
                    <ol className="breadcrumb justify-content-center" style={breadcrumb}>
                        {
                            navs.map((nav, navIndex) => {
                                const active = isCurrent(nav) ? 'fw-bold text-blue' : 'disabled';
                                return (
                                    <li key={navIndex} className="breadcrumb-item align-items-center d-flex">
                                        <button className={`btn ${active}`}>
                                            {nav}
                                        </button>
                                    </li>
                                );
                            })
                        }
                    </ol>
                </nav>
            </div>

        </>
    )
}

export default AddressProgressBreadCrumb

